<app-navbar-style-one></app-navbar-style-one>

<div class="home-slider owl-carousel owl-theme">
    <div class="slider-item" 
        style="background-image: url('../../../assets/img/home2/order-online.jpg');">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Order Online</h1>
                        <p>"Craving wings or sandwiches? Order online and we'll have it hot and ready!"</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="map-section" >
    <!-- Delivery/Pickup Buttons -->
    <div class="delivery-options mt-5 text-center">
        <div class="btn-group" role="group">
            <button 
                type="button" 
                class="btn btn-delivery" 
                [class.active]="deliveryOption === 'delivery'"
                (click)="setDeliveryOption('delivery')">
                Delivery
            </button>
            <button 
                type="button" 
                class="btn btn-pickup" 
                [class.active]="deliveryOption === 'pickup'"
                (click)="setDeliveryOption('pickup')">
                Pick Up
            </button>
        </div>
    </div>

    <div class="container mt-3">
        <div class="row">
            <div class="col-md-6 mt-3 mb-4">
                <h2 class="titleForMap">Please write location</h2>
                <input type="text" id="addressInputAutoComplete" placeholder="Enter your address" class="form-control mb-3" />
                <div class="text-center mt-5">
                    <button class="btn btn-primary" (click)="firstStepCompleted()" [disabled]="!isLocationSelected()">Next</button>
                </div>
            </div>

            <div class="col-md-6 mt-3 mb-5">
                <div #gmap style="width: 100%; height: 500px;border-radius: 20px;"></div>
                <!-- <p>{{selectedLat}}</p>
                <p>{{selectedLng}}</p> -->
            </div>
        </div>
    </div>
</section>


<section class="mainMenu mt-4 mb-5" *ngIf="stepNumTwo">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 text-center">
                <span class="currentRoute">{{'Main Courses' | titlecase}}</span>
            </div>
            <div class="col-12 mt-5 items">
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12 mt-5">
                        <div class="menu-item">
                            <img src="../../../../assets/img/home2/food.png" class="itemImage" width="220" alt="Images">
                            <h2>Woodfired Margherita Pizza</h2>
                            <p>Classic thin-crust pizza with fresh mozzarella and basil.</p>
                            <a class="">Read more</a>
                            <div class="menu-actions text-center mt-3">
                                <button data-bs-toggle="modal" data-bs-target="#itemModalDetails" class="btn btn-primary">Order Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Modal -->
<div class="modal fade" id="itemModalDetails" data-bs-keyboard="false" 
    tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="itemModalDetailsLabel">Spicy Chicken Wings</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-6">
                            <h5 class="fw-bold mb-3 descriptionTitle">Description</h5>
                            <p class="mb-4 descriptionParagraph">Perfectly spiced wings with a smoky BBQ glaze.</p>
                            
                            <!-- Size Selection -->
                            <div class="list-group mb-4 sizeDiv">
                                <h5 class="fw-bold mb-1">Size</h5>
                                <label class="list-group-item d-flex justify-content-between align-items-center">
                                    Small - $16
                                    <input type="radio" name="size" class="form-check-input" checked>
                                </label>
                                <label class="list-group-item d-flex justify-content-between align-items-center">
                                    Medium - $16
                                    <input type="radio" name="size" class="form-check-input">
                                </label>
                                <label class="list-group-item d-flex justify-content-between align-items-center">
                                    Large - $16
                                    <input type="radio" name="size" class="form-check-input">
                                </label>
                            </div>
                            
                            <!-- Extras -->
                            <div class="list-group extraDiv mb-4">
                                <h5 class="fw-bold mb-1">Extras</h5>
                                <label class="list-group-item d-flex justify-content-between align-items-center">
                                    Mix Cheese - $0
                                    <input type="checkbox" class="form-check-input">
                                </label>
                                <label class="list-group-item d-flex justify-content-between align-items-center">
                                    Ranch Sauce - $0
                                    <input type="checkbox" class="form-check-input">
                                </label>
                                <label class="list-group-item d-flex justify-content-between align-items-center">
                                    BBQ Sauce - $0
                                    <input type="checkbox" class="form-check-input">
                                </label>
                                <label class="list-group-item d-flex justify-content-between align-items-center">
                                    Mayonnaise - $0
                                    <input type="checkbox" class="form-check-input">
                                </label>
                            </div>
                            
                            <!-- Total -->
                            <div class="d-flex justify-content-between align-items-center mb-4">
                                <h5 class="fw-bold mb-0">Total</h5>
                                <h4 class="mb-0">$120</h4>
                            </div>
                        </div>
                        <div class="col-lg-6 quantityImageSection text-center">
                            <img src="../../../../assets/img/home2/wings.png" class="productImage mt-5" width="300" height="300" alt="Spicy Chicken Wings">
                            <!-- Quantity Selector -->
                            <div class="d-flex align-items-center mt-5 mb-5 justify-content-center">
                                <button class="btn quantity-btn" (click)="decreaseQuantity()">
                                    <i class="bx bx-minus"></i>
                                </button>
                                
                                <input type="number" id="quantity" class="form-control quantity-input text-center mx-2" 
                                    [(ngModel)]="quantity" min="1" max="99" style="width: 60px;">
                                
                                <button class="btn quantity-btn" (click)="increaseQuantity()">
                                    <i class="bx bx-plus"></i>
                                </button>
                            </div>
                            
                            <!-- Add to Cart Button -->
                            <button class="btn btn-primary add-to-cart-btn" (click)="addToCart()">
                                <i class="bx bx-shopping-cart me-2"></i> Add To Cart
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Understood</button>
            </div> -->
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>